import React from 'react'

const StepIcon = ({ active, type }) => {
  const stroke = active ? 'white' : '#7c3aed'
  if (type === 'step2') {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6"
      >
        <rect x="10" y="12" width="28" height="24" rx="4" stroke={stroke} strokeWidth="3" />
        <path d="M18 18h12" stroke={stroke} strokeWidth="3" strokeLinecap="round" />
        <path d="M18 24h16" stroke={stroke} strokeWidth="3" strokeLinecap="round" />
        <path d="M18 30h10" stroke={stroke} strokeWidth="3" strokeLinecap="round" />
      </svg>
    )
  }
  if (type === 'step3') {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6"
      >
        <circle cx="24" cy="18" r="8" stroke={stroke} strokeWidth="3" />
        <path d="M12 36c2.5-4 7-6 12-6s9.5 2 12 6" stroke={stroke} strokeWidth="3" strokeLinecap="round" />
        <path
          d="M30 26l4 5 6-9"
          stroke={stroke}
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="h-6 w-6"
    >
      <path
        d="M16 14h-4a4 4 0 00-4 4v16a4 4 0 004 4h24a4 4 0 004-4V18a4 4 0 00-4-4h-4l-2.5-4h-11L16 14z"
        stroke={stroke}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="24" cy="25" r="6" stroke={stroke} strokeWidth="3" />
    </svg>
  )
}

export default StepIcon
